const socialMedia = [
    "Facebook",
    "Instagram",
    "LinkedIn",
    "Youtube",
    "Twitter"]

module.exports = { socialMedia }